<template>
  <div class="pagination">
    <div class="cursor">
      <span :class="{hidden : queryInfo.first == 0}">
        <Button @click="goFirst()" class="pagination-button">&lt;&lt;</Button>
        <Button @click="goPrev()" class="pagination-button">&lt;</Button>
      </span>

      <span class="current-page">
        {{ 1 + queryInfo.first }}-{{ last }}
      </span>

      <span :class="{hidden : last == queryInfo.total}">
        <Button @click="goNext()" class="pagination-button">&gt;</Button>
        <Button @click="goLast()" class="pagination-button">&gt;&gt;</Button>
      </span>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button.vue'

@Component({
  name: 'Pagination',
  components: { Button }
})
class Pagination extends Vue {
  get last() {
    if (this.queryInfo.first + this.queryInfo.limit <= this.queryInfo.total) {
      return this.queryInfo.first + this.queryInfo.limit
    }
    return this.queryInfo.total
  }

  get orderby() {
    return this.queryInfo.orderby
  }

  set orderby(value) {
    this.changeOrderBy(value)
  }

  get orderasc() {
    return this.queryInfo.orderasc
  }

  set orderasc(value) {
    this.changeOrderAsc(value)
  }
}

export default Pagination
</script>

<style lang="less" scoped>
.hidden {
  visibility: hidden;
  pointer-events: none;
}
.pagination {
  margin-top: var(--margin--small);
  margin-bottom: var(--margin--small);
}

.current-page {
  margin: var(--margin--medium) 0;
  padding: var(--margin--tiny) var(--margin--small);

  background-color: rgba(0, 0, 0, 0.07);
  border: 2px solid transparent;
}

.pagination-button {
  margin-left: var(--margin--small);
  margin-right: var(--margin--small);
}
</style>
